export const STAR_ICON = '/ui/telegram-stars-icon.png';
export const SHELL_ICON = '/ui/shell-icon.png';
export const AD_VOTE_COOLDOWN_KEY = 'election_ad_vote_cd'; // JSON map: { [candidateId]: timestamp }
export const AD_VOTE_COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes
